import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

export const EmptyStateContainer = styled(FlexColumn)`
    justify-content: center;
    align-items: center;
    margin-top: 72px;
    margin-bottom: 84px;

    @media (max-height: 800px) {
        margin-top: 22px;
        margin-bottom: 32px;
    }
`;

export const EmptyStateImage = styled.img`
    width: 161px;
`;

export const EmptyStateText = styled.p`
    text-align: center;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])}
    margin: 0;
    padding: 36px 88px 0;
`;

export const EmptyStateSubText = styled.p`
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
    margin: 0;
`;

const ListWrapper = styled.div`
    margin: 0 16px;
`;

export const ItemWrapper = styled.div`
    margin-bottom: 8px;
`;
